export default class DestinationManager {
    constructor() {
        this.destinationTemplate = document.querySelector('#destination-item');
    }

    createDestinationElement(destination, onClickAction) {
        let destinationContainer = this.destinationTemplate.content.cloneNode(true);
        destinationContainer.querySelector('[data-target="destination-name"]').innerHTML = destination.nom;

        let imageContainer = destinationContainer.querySelector('.img-container');
        if (destination.image) {
            let image = document.createElement('img');
            image.src = destination.image;
            imageContainer.appendChild(image);
        } else {
            let icon = document.createElement('i');
            icon.classList.add('ci', 'ci-map-marker', 'ci-s-20');
            imageContainer.classList.add('no-image');
            imageContainer.appendChild(icon);
        }
        destinationContainer.querySelector('[data-target="area-name"]').innerHTML = destination.areaText;
        if (destination.category) {
            for (let i = 0; i < destination.category.value; i++) {
                let starKeyElement = document.createElement("i");
                starKeyElement.classList.add('ci', 'ci-' + destination.category.type, 'ci-s-12', 'color-category-light');
                destinationContainer.querySelector('[data-target="category-container"]').append(starKeyElement);
            }
        }
        let destinationElement = destinationContainer.querySelector('[data-target="destination"]')

        destinationElement.setAttribute('data-id', destination.id);

        if (destination.destinationType) {
            destinationElement.setAttribute('data-type', destination.destinationType);
        }

        destinationElement.addEventListener("click", (event) => {
            onClickAction(event.currentTarget);
        });

        return destinationContainer;
    }
}
